export default {
	SET_USER(state, user) {
		state.user = user;
	},
	SET_TOKEN(state, token) {
		state.token = token;
	},
	SET_COMPANY(state, company) {
		state.company = company;
	},
	SET_PRODUCTS(state, products) {
		state.products = products;
	},
	SET_IS_MOBILE(state, isMobile) {
		state.isMobile = isMobile;
	},
};



// WEBPACK FOOTER //
// ./src/store/mutations.js